import React, {useEffect, useState} from "react";
import logoWhite from "../../../../assets/images/logo-white.png";
import {Link} from "react-router-dom";
import Drawer from "rc-drawer";
import PublicHeaderNav from "./PublicHeaderNav";
import {widget, route, trans} from "../../../modulesCompiler";
import {ChevronsUp, Filter, Menu, Search, ShoppingBag, X} from "react-feather";
import {useSwipeable} from "react-swipeable";


const PublicHeader = () => {
    const [stickyHeader, setStickyHeader] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const swipeRightToClose = useSwipeable({
        onSwipedRight: (eventData) => setDrawerOpen(false),
    });

    useEffect(() => {
        window.onscroll = function(ev) {
            if (window.pageYOffset > 200) {
                setStickyHeader(true);
            } else  {
                setStickyHeader(false);
            }
        };
    },[]);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            <Drawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                handler={null}
                className="d-md-none" placement="right" level={null} width="80vw">
                <button onClick={()=>setDrawerOpen(false)}
                        className="btn btn-link text-white position-absolute" style={{bottom: 10, right: 10}}>
                    <X size={20} strokeWidth={3} />
                </button>

                <div {...swipeRightToClose} className="bg-primary h-100">
                    <div className="border-bottom p-2 text-center">
                        <img src={logoWhite} className="img-fluid" alt="HORUS LOGO" />
                    </div>
                    <div className="p-2">
                        <PublicHeaderNav mobile={true} />
                    </div>
                </div>
            </Drawer>

            <div className="bg-primary">
                <div className={`${stickyHeader ? "scroll_menu_fixed shadow-sm bg-primary" : ""}`}>
                <header className="container">
                    <div className="d-md-flex align-items-center position-relative pt-2 pb-2">
                        <div className="d-none d-md-block col">
                            <PublicHeaderNav />
                        </div>

                        <div className="col text-center header_logo mb-4 mb-md-0">
                            <Link to={route("public.index")}>
                                <img src={logoWhite} className="img-fluid" alt="Logo" width={210} />
                            </Link>
                        </div>

                        <div className="col justify-content-md-end justify-content-center align-items-center d-flex">
                            {widget("lang.DropDown")}
                            {widget("products.SearchModal", {
                                button: <button className="btn btn-link btn-link-dark text-white ms-2">
                                        <Search size={24} />
                                    </button>
                            })}
                            {widget("orders.BasketDrawerToggle", {
                                button: <button className="btn btn-link btn-link-dark shadow-none">
                                    <ShoppingBag size={24} className="text-white"/>
                                </button>, invert: true
                            })}
                        </div>
                    </div>
                </header>
                </div>
                {stickyHeader &&
                <div className="d-none d-md-block" style={{height: 120}} />}
            </div>

            <div className="mobile_menu d-md-none shadow-sm rounded-3 border border-primary">
               <div className="row g-0 text-center text-uppercase fs-s fw-bold">
                   <div className="col">
                       {widget("products.SearchModal", {
                           button: <button className="btn btn-link btn-sm w-100 shadow-none">
                                   <Search size={18} strokeWidth={3} />
                                   <div className="text-uppercase fw-bold fs-xs">
                                       {trans("pretraga")}
                                   </div>
                               </button>
                       })}
                   </div>
                   <div className="col">
                       {widget("orders.BasketDrawerToggle", {
                           button: <button className="btn btn-link btn-sm w-100 shadow-none">
                               <ShoppingBag size={18} strokeWidth={3} />
                               <div className="text-uppercase fw-bold fs-xs">
                                   {trans("korpa")}
                               </div>
                           </button>
                       })}
                   </div>
                   <div className="col">
                       <button onClick={() => setDrawerOpen(true)}
                               className="btn btn-link btn-sm w-100 shadow-none">
                           <Menu size={18} strokeWidth={3} />
                           <div className="text-uppercase fw-bold fs-xs">
                               {trans("strane")}
                           </div>
                       </button>
                   </div>
                   <div className="col">
                       {widget("categories.OnlyCategoriesDrawer", {
                           button: <button className="btn btn-link btn-sm w-100 shadow-none">
                               <Filter size={18} strokeWidth={3} />
                               <div className="text-uppercase fw-bold fs-xs">
                                   {trans("kategorije")}
                               </div>
                           </button>
                       })}
                   </div>
                   {stickyHeader &&
                   <div className="col">
                       <button onClick={scrollToTop} className="btn btn-link w-100 h-100 shadow-none">
                           <ChevronsUp />
                       </button>
                   </div>}
               </div>
            </div>

            {stickyHeader &&
            <button onClick={scrollToTop}
                    className="btn btn-primary position-fixed shadow-none d-none d-md-block" style={{right: 15, bottom: 30, zIndex: 100}}>
                <ChevronsUp />
            </button>}
        </div>
    )
}

export default PublicHeader;
